import api from '../api';

export const userProfileApi = api.injectEndpoints({
  endpoints: builder => ({
    updateUserDetails: builder.mutation({
      query: body => ({
        url: 'api/user/profile/update',
        method: 'POST',
        body
      })
    }),
    fetchUserDetails: builder.query({
      query: () => ({
        url: 'api/user/getbyuserprofile',
        method: 'GET'
      })
    }),
    fetchUserBadge: builder.query({
      query: () => ({
        url: 'api/user/badges',
        method: 'GET'
      })
    }),
    FetchDashboardWidgets: builder.query({
      query: ({ userId }) => ({
        url: 'api/dashboard/performance/analysis',
        method: 'GET',
        params: { userId }
      })
    }),
    FetchDashboardWidgets2: builder.query({
      query: ({ userId }) => ({
        url: '/api/dashboard/avgscores/companywise',
        method: 'GET',
        params: { userId }
      })
    }),
    FetchUserTests: builder.query({
      query: ({ userId }) => ({
        url: 'api/dashboard/usertestcount',
        method: 'GET',
        params: { userId }
      })
    }),
    fetchUserTiles: builder.query({
      query: ({ userId }) => ({
        url: 'api/dashboard/writtentest/overview',
        method: 'GET',
        params: { userId }
      })
    }),
    fetchAverageTime: builder.query({
      query: ({ userId }) => ({
        url: 'api/dashboard/recenttests/averagetime',
        method: 'GET',
        params: { userId }
      })
    }),
    fetchAverageScore: builder.query({
      query: ({ userId }) => ({
        url: 'api/dashboard/test/scores/average',
        method: 'GET',
        params: { userId }
      })
    })
  })
});

export const {
  useUpdateUserDetailsMutation,
  useLazyFetchUserDetailsQuery,
  useLazyFetchUserBadgeQuery,
  useLazyFetchDashboardWidgetsQuery,
  useLazyFetchDashboardWidgets2Query,
  useLazyFetchUserTestsQuery,
  useLazyFetchUserTilesQuery,
  useLazyFetchAverageTimeQuery,
  useLazyFetchAverageScoreQuery
} = userProfileApi;
